'use strict';

// import 'whatwg-fetch';
// import './lib/polyfills';

// import './lib/buttons';

import navigation from './modules/main-nav.js';
import langPicker from './modules/lang-picker.js';
import secondaryNav from './modules/secondary-nav.js';
import siteHeaderHomeKitProgram from './modules/site-header-home-kit-program.js';
import addonInput from './modules/addon-input.js';
import lazyLoad from './modules/lazy-load.js';
import heroAnimations from './modules/hero-animations.js';
import headerAnimations from './modules/header-animations.js';
import specialFeatureA from './modules/special-feature-a.js';
import specialFeatureB from './modules/special-feature-b.js';
import accordion from './modules/accordion.js';
import sectionBuyNow from './modules/section-buy-now.js';
import sectionNavStickyButton from './modules/section-nav-sticky-button.js';
import sectionNav from './modules/section-nav.js';
import vimeo from './modules/vimeo.js';
import youtube from './modules/youtube.js';
import multicardAnimations from './modules/multicard-animation.js';
import multicard from './modules/multicard.js';
import bgCirclesAnimation from './modules/bg-circles-animation.js';
import smoothScroll from './modules/smooth-scroll.js';
import scrollToTop from './modules/scroll-to-top.js';
import loadMore from './modules/load-more.js';
import './modules/lottie.js';
import jobsFilter from './modules/jobs-filter.js';
import tabs from './modules/tabs.js';
import iframePreloader from './modules/iframe-preloader.js';
import googleMaps from './modules/google-maps.js';
import newsletterCta from './modules/newsletter-cta';
import newsletterModal from './modules/newsletter-modal';
import calculator from './modules/roi-calculator.js';
import buttonDropdown from './modules/button-dropdown.js';
import share from './modules/share.js';
import blog from './modules/blog.js';
import featuresSplitSlider from './modules/features-split-slider.js';
import featuresSplitVideo from './modules/features-split-video.js';
import quotesSlider from './modules/quotes-slider.js';
import sliderSplit from './modules/slider-split.js';
import queryLoadMoreGrid from './modules/query-load-more-grid.js';
import hubspotModal from './modules/hubspot-modal.js';
import marketo from './modules/marketo.js';
import formTabs from './modules/form-tabs.js';
import notificationBanner from './modules/notification-banner.js';
import modal from './modules/modal.js';
import roiAnalysis from './modules/roi-analysis.js';
import utm from './modules/utm.js';
import browserFallback from './modules/browser-fallback.js';
import lungCancerCalculator from './modules/lung-cancer-calculator.js';
import wheelAccordion from './modules/wheel-accordion.js';
import wheelCarousel from './modules/wheel-carousel.js';
import cardTabs from './modules/card-tabs.js';
import timeline from './modules/timeline.js';
import videoPlayer from './modules/video-player.js';
import educationlResourcesArchive from './modules/educational-resources-archive.js';
import teamMembersArchive from './modules/team-members-archive.js';

navigation.init();
langPicker.init();
secondaryNav.init();
siteHeaderHomeKitProgram.init();
addonInput.init();
lazyLoad.init();
heroAnimations.init();
headerAnimations.init();
accordion.init();
vimeo.init();
youtube.init();
sectionBuyNow.init();
sectionNavStickyButton.init();
sectionNav.init();
scrollToTop.init();
jobsFilter.init();
tabs.init();
iframePreloader.init();
newsletterModal.init();
calculator.init();
roiAnalysis.init();
buttonDropdown.init();
share.init();
blog.init();
multicard.init();
featuresSplitSlider.init();
featuresSplitVideo.init();
quotesSlider.init();
sliderSplit.init();
queryLoadMoreGrid.init();
formTabs.init();
notificationBanner.init();
modal.init();
utm.init();
browserFallback.init();
lungCancerCalculator.init();
wheelAccordion.init();
wheelCarousel.init();
cardTabs.init();
timeline.init();
videoPlayer.init();
educationlResourcesArchive.init();
teamMembersArchive.init();

/**
 * The order on these matters
 */
window.addEventListener('load', (event) => {
  specialFeatureB.init();
  specialFeatureA.init();
  multicardAnimations.init();
  bgCirclesAnimation.init();
  smoothScroll.init();
  loadMore.init();
  googleMaps.init();
  newsletterCta.init();
  hubspotModal.init();
  marketo.init();
});
